// ----------------------------------------------------------------------

export default function IconButton(theme) {
  // Get icon size from theme config if available
  const iconSize = theme.iconSize || 20;
  
  return {
    MuiIconButton: {
      styleOverrides: {
        root: {
          '& .MuiSvgIcon-root': {
            fontSize: iconSize,
          },
          '& svg': {
            width: iconSize,
            height: iconSize,
          }
        },
        sizeSmall: {
          '& .MuiSvgIcon-root': {
            fontSize: iconSize * 0.8,
          },
          '& svg': {
            width: iconSize * 0.8,
            height: iconSize * 0.8,
          }
        },
        sizeLarge: {
          '& .MuiSvgIcon-root': {
            fontSize: iconSize * 1.2,
          },
          '& svg': {
            width: iconSize * 1.2,
            height: iconSize * 1.2,
          }
        }
      }
    }
  };
}
